import { LinkDefinition } from "./link";
class Definition extends LinkDefinition {
  static deserialize(data) {
    if (data.type !== Definition.type) {
      throw new Error(
        `Link: expected type ${Definition.type}, got ${data.type}`
      );
    }
    const { config } = Definition.schema.definition.parse(data);
    return new GenericLinkDefinition(config);
  }
}
class GenericLinkDefinition extends Definition {
}
const GenericLink = (config) => new GenericLinkDefinition(config ?? {});
export {
  GenericLink,
  GenericLinkDefinition
};
//# sourceMappingURL=generic-link.js.map